/**
 * The AI's own subs and moves, made visible (slice 11c, the 2026-10-20 playtest: the player could
 * not tell how often the AI changed its starters). When the player defends, the AI offense's
 * window is known before the call: the session plays it through the sim's `applyWindow` and the
 * text box says each change in the sim's own words (`gameEventLine`: "Team Electabuzz brings
 * Rhydon in at DL1."), and the board tags those rows on the THEM side. When the player is on
 * offense, the AI defense answers after Snap, and the same lines come with the snap's events.
 */
import { gameEventLine, type GameEvent, type Team, type TeamId } from '@tdmons/sim';

export type AiChange = Extract<GameEvent, { type: 'sub' }>;

/** The board's tags for the other side: slots with a new Pokémon, slots in a move. */
export interface TheirChanges {
  drafted: ReadonlySet<string>;
  moved: ReadonlySet<string>;
}

export function theirChanges(changes: readonly AiChange[]): TheirChanges {
  const drafted = new Set<string>();
  const moved = new Set<string>();
  for (const c of changes) {
    if (!c.swap) drafted.add(c.slot);
    else {
      moved.add(c.slot);
      if (c.from) moved.add(c.from);
    }
  }
  return { drafted, moved };
}

/** One plain line per change, the sim's own wording. */
export function changeLines(changes: readonly AiChange[], teams: Record<TeamId, Team>): string[] {
  return changes.flatMap((c) => gameEventLine(c, teams) ?? []);
}
